import { useState, useReducer, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import axios from 'axios';
import Data from "../Words/Words";
import Common from "../Words/Common";
import W1000 from "../Words/W1000";
import W2000 from "../Words/W2000";
import W3000 from "../Words/W3000";
import W4000 from "../Words/W4000";
import States from "../Words/States";
import Cities from "../Words/Cities";
import WordsNames from "../Words/WordsNames";
import WordsWorksOfArt from "../Words/WordsWorksOfArt";
import flag from '../img/flag.png'
import correct from "../files/correct.mp3";
import wrong from "../files/wrong.mp3";
import bank from '../img/stats/bank.png'
import AuthContext from '../context/AuthProvider';





function reducer(words, action) {
    switch (action.type) {
        case "SHUFFLE":
            console.log("shuffling");
            var TEMP =
                words.map((el) => {
                    return {
                        id: el.id,
                        pronunciation: el.pronunciation,
                        word: el.word,
                        progress: el.progress,
                        sum: el.progress.reduce((a, b) => a + b, 0),
                    };
                }
                )
            //remove word for which all N tries have been succesfull
            TEMP = TEMP.filter((el) => (el.progress.length !== el.sum));

            return TEMP.sort(function (a, b) {
                return a.sum - b.sum;
            })
        case "WATER":
            return action.payload.words
        default:
            return words;
    }
}

function sayIt(word) {
    var utterance = new SpeechSynthesisUtterance(word);
    var voices = window.speechSynthesis.getVoices();
    utterance.voice = voices.filter(function (voice) { return voice.name == 'Google UK English Female'; })[0];
    //console.log("Glasovi:",window.speechSynthesis.getVoices());
    // utterance.pitch = 1;
    utterance.rate = 0.8;
    speechSynthesis.speak(utterance);
    // console.log
}


function SpellTellPractice() {

    const [inputCurrent, setInputCurrent] = useState("");
    const [inputState, setInputState] = useState(false); //if what user typed matches offered word
    const [response, setResponse] = useState({
        exists: false,
        word: [{ offered: "first", typed: "second" }],
    });
    const ind = useRef(0);
    const sayCounter = useRef(0); //used in useEffect to start sayIt function
    const [words, dispatch] = useReducer(reducer, W1000);
    const [wrongList, setWrongList] = useState([]);

    const { logged, setLogged, token, setToken, setFname } = useContext(AuthContext);

    const getWords = async (data) => {
        // const bodyParameters = data;
        // console.log("body", bodyParameters);
        axios.get(
            'https://api.spelltell.com/api/words',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
            }
        ).then(
            res => {
                console.log("radi", res.data.data)
                const fetchedWords = res.data.data.map(el => {
                    return {
                        //flattens the JSON that comes formt he server
                        ...el, ...el.word,  progress
                        //if progress is null (word have never been used) give it 0,0,0 values for progres, otherwise convert Intager to string
                            : (el.progress==null)?[0,0,0]:Array.from(String(el.pogress), Number)

                    }
                });
                console.log(fetchedWords)
                dispatch({ type: "WATER", payload: { words: fetchedWords } })

            }
        ).catch(res => {
            console.log("error->", res);
        });
    }

    useEffect(
        () => {
            getWords();//grab words from databas on load
            sayIt(words[ind.current].word)
        }, []
    )


    useEffect(
        () => {
            //check how many wording is left in the deck; if it's zero; sayIt function will get undefined for an argument
            //we can either check if words[ind.current].word is undefined, or we can check if length of words is ZERO beforehand
            sayIt((words.length !== 0) ? words[ind.current].word : "Congratulations! You have finished all words in this deck!")
        }, [sayCounter.current] //[words[ind.current].word]
    )

    useEffect(
        () => {
            var browserData = window.localStorage.getItem('SPELLTELL_WORDS');
            var browserWrongList = window.localStorage.getItem('SPELLTELL_WRONGLIST');

            if (browserData !== null) browserData = JSON.parse(browserData);
            if (browserData !== null) dispatch({ type: "WATER", payload: { words: browserData } });
            if (browserWrongList !== null) setWrongList(JSON.parse(browserWrongList));
            //console.log(JSON.parse(browserWrongList));
        }, []
    )

    useEffect(
        () => {
            window.localStorage.setItem('SPELLTELL_WORDS', JSON.stringify(words));
            window.localStorage.setItem('SPELLTELL_WRONGLIST', JSON.stringify(wrongList));
            //console.log("changed", words);
            //console.log("response");
        }, [response]
    )

    function repeatOnKeyDown(e) {
        //when cursor is in Input form and CTRL is pressed down, pronounce the  word
        if (e.key === "Control") {
            sayIt(words[ind.current].word);
        }
    }



    const sendResult = async (result) => {
        // const bodyParameters = data;
        // console.log("body", bodyParameters);
        let now = {
            "id": words[ind.current].id,
            correct: result ? 1 : 0,
            progress: words[ind.current].progress.join(''),
            first_time_learned: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
            //previus sum -> words[ind.current].progress_sum
            progress_sum: words[ind.current].progress.reduce((partialSum, a) => partialSum + a, 0).toString()
        };
        console.log("sending to post api:", now);
        axios.post(
            'https://api.spelltell.com/api/words', now,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
            }
        ).then(
            res => {
                console.log("result", res)

            }
        ).catch(res => {
            console.error("error->", res.response.data);
        });
    }



    function handleSubmit(e) {
        e.preventDefault();
        sayCounter.current++;
        //console.log(sayCounter.current);
        if (ind.current < words.length) {
            //console.log(ind.current);
            setResponse({
                exists: true,
                word: [
                    {
                        offered: words[ind.current].word.trim(),
                        typed: inputCurrent.trim(),
                    },
                ],
            });

            if (words[ind.current].word.trim().toLowerCase() === inputCurrent.trim().toLowerCase()) {
                setInputState(true);
                words[ind.current].progress.unshift(1);
                words[ind.current].progress.pop();
                sendResult(true);
                new Audio(correct).play();
            } else {
                new Audio(wrong).play();
                words[ind.current].progress.unshift(0);
                words[ind.current].progress.pop();
                sendResult(false);
                console.log(wrongList);
                console.log("current:", words[ind.current].word)


                let foundInWrong = false;
                if (wrongList.map(elm => {
                    if (elm.word == words[ind.current].word) foundInWrong = true
                }))
                    if (!foundInWrong) { setWrongList([...wrongList, words[ind.current]]); };

                setInputState(false);

            }
            //if this is the last element of the array; rewind the Ind and start from the beggining of the array;
            if (ind.current === words.length - 1) {
                ind.current = 0;
                //if this is the last word in current setup, shuffle deck
                dispatch({ type: "SHUFFLE" });
            } else {
                ind.current = ind.current + 1;
            }
        }
        //console.log(ind.current);
        setInputCurrent("");
    }


    return (
        <>
            <div>
                <div className=" flex  center">
                    <div className="basis100 keepTyping">Keep typing, we will take care of the rest!</div>
                </div>

                {/* <div className="statsBox flex statsBox_last statsBox_first">
                    <div className="basis25">Practice from category:</div>
                    <div className="basis75 bankStatsRight ">

                        <div> <select>
                            <option value="top1000">Top1000</option>
                            <option value="top2000">Top2000</option>
                            <option value="top3000">Top3000</option>
                            <option value="common">Common Mistakes</option>

                        </select></div>
                    </div>
                </div> */}

                {/* <div className="ChooseDeck">
                    <h3 onClick={() => {
                        dispatch({
                            type: "WATER", payload: {
                                words: Common
                            }
                        });
                        ind.current = 0;
                        sayCounter.current++;
                    }}>Common Mistakes</h3>

                    <h3 onClick={() => {
                        dispatch({
                            type: "WATER", payload: {
                                words: Data
                            }
                        });
                        ind.current = 0;
                        sayCounter.current++;
                    }}>Test Deck</h3>

                    <h3 onClick={() => {
                        dispatch({
                            type: "WATER", payload: {
                                words: wrongList
                            }
                        });
                        ind.current = 0;
                        sayCounter.current++;
                    }}>Wrong (<span style={{ fontWeight: "400", color: "purple" }}>{wrongList.length}</span>)</h3>


                </div> */}


                {(words.length === 0) ? <div className="flag"> <img className="img-resp" src={flag} /> <h2>Congrats! You've finished all words in this deck!!</h2></div> : (
                    <div id="spelltellBox" className="spelltellBox">

                        <div className="spelltellBox__header">
                            <h1>{words[ind.current].pronunciation}</h1>
                        </div>


                        <div className="spelltellBox__body">

                            <div className="spelltellBox__body__input">
                                <form onSubmit={handleSubmit}>
                                    <input
                                        placeholder="type..."
                                        tabIndex={1}
                                        spellCheck="false"
                                        type="text"
                                        name="SpellTellInput"
                                        autoComplete="off"
                                        value={inputCurrent}
                                        onChange={(e) => setInputCurrent(e.target.value)}
                                        onKeyDown={(e) => repeatOnKeyDown(e)}
                                    />
                                </form>
                            </div>
                            {
                                <h2>
                                    {response.exists &&
                                        (inputState ? (
                                            <>
                                                <span style={{ color: "teal" }}>
                                                    {response.word[0].offered}
                                                </span>{" "}
                                            </>
                                        ) : (
                                            <>
                                                <span
                                                    style={{ color: "#a31576", textDecoration: "line-through" }}
                                                >
                                                    {response.word[0].typed}
                                                </span>
                                                {" → "}
                                                <span style={{ color: "teal" }}>
                                                    {response.word[0].offered}
                                                </span>
                                            </>
                                        ))}
                                </h2>
                            }
                            <div className="spelltellBox__body__button">

                                <button tabIndex="3" className="btn-outline-primary"
                                    onClick={() => {
                                        sayIt(words[ind.current].word);
                                    }}
                                >
                                    Repeat
                                </button>
                                <button tabIndex="2" lue="Submit" onClick={(e) => { handleSubmit(e) }} className="btn-primary">CHECK ►</button>

                            </div>
                        </div>

                    </div>)}



                <Link className="statsBoxLink" to="/stats">
                    <div className="statsBox flex statsBox_first statsBox_last">
                        <div className="basis25 center viewBank"><img className="img-resp " src={bank} /> (view bank)</div>
                        <div className="basis75 bankStatsRight"> <div className="counter">302434 hits</div>  <div className="bankWords">3024</div> <div className="label">learned words</div></div>
                    </div>
                </Link>



            </div>
            {(wrongList.length) ? (<div className="statsBox  statsBox_first statsBox_last">
                <div className="WrongWordsListHeadline"><h3>Words You need to practice:</h3></div>
                <div className="WrongWordsList ">
                    {wrongList.map(elm => <span  >{elm.word} </span>)}
                </div></div>) : ""}
        </>

    );
}

export default SpellTellPractice

